module.exports = __webpack_public_path__ + "static/img/icon_vip3.5331af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_vip3.png
// module id = tPMi
// module chunks = 192